<template>
  <div class="stripe-payout-list-table">
    <el-table :data="rows" ref="table" v-loading="loading">
      <el-table-column :label="fields.arrivalDate.label" :prop="fields.arrivalDate.name">
        <div slot-scope="scope">
          <span>{{presenter(scope.row, 'arrivalDate')}}</span>
        </div>
      </el-table-column>

      <el-table-column :label="fields.method.label" :prop="fields.method.name">
        <div
          v-if="scope.row.externalAccount"
          slot-scope="scope"
          class="stripe-payout-list-table__card"
        >
          <template v-if="scope.row.externalAccount.type === 'card'">
            <img
              v-if="scope.row.externalAccount && scope.row.externalAccount.brand"
              :src="`/images/cards/${scope.row.externalAccount.brand}.png`"
              class="stripe-payout-list-table__card__img"
            />
            <img v-else src="/images/cards/default.png" class="stripe-payout-list-table__card__img" />
            <span
              class="stripe-payout-list-table__card__last4"
              v-text="`****${scope.row.externalAccount.last4}`"
            />
          </template>
          <template v-else>
            <i class="icon-home stripe-payout-list-table__card__icon" />
            <div class="stripe-payout-list-table__card__last4">
              <span v-text="`${scope.row.externalAccount.bankName}`" />
              <br />
              <span
                class="stripe-payout-list-table__card__last4__small"
                v-text="`****${scope.row.externalAccount.last4}`"
              />
            </div>
          </template>
        </div>
      </el-table-column>

      <el-table-column :label="fields.amount.label" :prop="fields.amount.name">
        <div slot-scope="scope">
          <app-i18n-amount
            :amount="scope.row.amount"
            :currency="scope.row.currency"
            currency-display="code"
          />
        </div>
      </el-table-column>

      <el-table-column :label="fields.status.label" :prop="fields.status.name">
        <template slot-scope="scope">
          <div class="stripe-payout-list-table__status">
            <i
              class="icon-radio-button-fill stripe-payout-list-table__status__icon"
              :style="getTagStyle('status', scope.row.status)"
            />
            <span
              class="stripe-payout-list-table__status__span"
            >{{ presenter(scope.row, 'status') }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="fields.type.label" :prop="fields.type.name">
        <div slot-scope="scope">
          <span class="stripe-payout-list-table__cell__span">
            <app-i18n
              v-if="scope.row.automatic"
              code="subpropertySettings.finantial.payoutSchedule.cardFrequency.placeholders.automatic"
            />
            <app-i18n
              v-else
              code="subpropertySettings.finantial.payoutSchedule.cardFrequency.placeholders.manual"
            />
          </span>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { StripePayoutModel } from '@modules/stripe/stripe-payout/stripe-payout-model';
import TagsFactory from '@shared/factories/tags-factory';

const { fields } = StripePayoutModel;

export default {
  name: 'app-stripe-payout-list-table',
  props: {
    connectedAccountId: {
      type: String,
      default: null,
    },
    inscriptionId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      rows: 'stripePayout/list/rows',
      loading: 'stripePayout/list/loading',
    }),

    fields() {
      return fields;
    },
  },
  created() {
    const {
      connectedAccountId: connectedAccount,
      inscriptionId: inscription,
    } = this;

    if (connectedAccount || inscription) {
      this.doFetch({
        filter: {
          ...(connectedAccount && { connectedAccount }),
          ...(inscription && { inscription }),
        },
      });
    }
  },
  methods: {
    ...mapActions({
      doFetch: 'stripePayout/list/doFetch',
    }),
    presenter(record, fieldName) {
      return StripePayoutModel.presenter(record, fieldName);
    },
    getTagStyle(keyEnum, valueEnum) {
      return new TagsFactory({
        entityName: 'stripePayout',
      }).getTagStyle({
        keyEnum: keyEnum,
        valueEnum: valueEnum,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stripe-payout-list-table {
  &__title {
    color: #404040;
    font-size: 18px;
    font-weight: 400;
    padding: 24px;
  }

  &__status {
    width: 120px;
    border-radius: 7px;
    text-transform: capitalize;
    box-shadow: 0 2px 5px 0 rgba(223, 223, 223, 0.7);
    font-size: 12px;
    color: #606266;
    font-weight: normal;
    letter-spacing: 0;
    padding: 10px 0px 6px 12px;

    display: grid;
    grid-template-areas: 'dot label';
    grid-template-columns: 20px;
    grid-template-rows: 20px;
    align-items: center;
  }

  &__cell__span {
    padding-left: 24px;
  }

  &__card {
    display: grid;
    grid-template-columns: 40px 1fr;
    grid-template-areas: 'icon last4';
    align-items: center;

    &__img {
      width: 40px;
      grid-area: icon;
    }

    &__icon {
      font-size: 20px;
      grid-area: icon;
    }

    &__last4 {
      grid-area: last4;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &__small {
        font-size: 12px;
      }
    }
  }
}
</style>

<style>
body .stripe-payout-list-table .el-table__row {
  cursor: default;
}
</style>
